import api from "../middlware/api";
import { BASE_URL } from "../constants";
import { camelToSnake } from "../utils/CamelToSnake";
import { VaccineFormData } from "../interfaces/vaccines";

export const getVaccines = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/vaccines`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getVaccineById = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/vaccines/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const createVaccine = (payload: VaccineFormData) => {
  return new Promise((resolve, reject) => {
    api
      .post(`${BASE_URL}/api/v1/vaccines`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const updateVaccine = (id: number | string, payload: VaccineFormData) => {
  return new Promise((resolve, reject) => {
    api
      .put(`${BASE_URL}/api/v1/vaccines/${id}`, camelToSnake(payload))
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const deleteVaccine = (id: number | string) => {
  return new Promise((resolve, reject) => {
    api
      .delete(`${BASE_URL}/api/v1/vaccines/${id}`)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const getVaccineSchedules = (params?: any) => {
  return new Promise((resolve, reject) => {
    api
      .get(`${BASE_URL}/api/v1/vaccine-schedules`, { params })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};
